import { ApiFilterBase, ApiPagedData } from "@skailer-com/uikit/core";

export interface ApiApiUser {
  id: number;
  name: string;
  is_archived: boolean;
  datetime_created: Date;
}

export interface ApiApiUserSave {
  name: string;
}

export interface ApiApiUserFilter extends ApiFilterBase {
  text?: string | null;
  page_size?: number;
}

export interface ApiApiTokenGenerate {
  name: string;
  expires_in_days: number | null;
}

export interface ApiApiTokenCreated {
  token: string;
  name: string;
  datetime_valid_to: Date;
}

export type ApiApiUserPagedData = ApiPagedData<ApiApiUser>;

export const ApiApiUsersFilterDefault: ApiApiUserFilter = {
  page_number: 1,
  page_size: 20,
  text: "",
};
